var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}]},_vm._l((_vm.dataIn.serviceList),function(item,index){return _c('div',{key:index},[_c('serviceDetail',{attrs:{"isReadonly":_vm.isReadonly,"dataIn":item,"contractList":_vm.contractList}})],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ad14c30","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/studyAbroad/workflow/serviceList.vue
// module id = Myvc
// module chunks = 0